import styled, {css} from "styled-components"

import {H6} from "@irati/ui/src/Typography"
import Icon from "@irati/ui/src/Icon"

interface LoaderProps {
  percent: number
}

export const DownloadCompleteSection = styled(H6)`
  display: flex;
  align-items: center;
  color: ${({theme}) => `${theme.colors.primary1}`};
`

export const DownloadCompleteIcon = styled(Icon)`
  ${({theme}) => css`
    fill: ${theme.colors.greys.white};
    border: 2px solid ${theme.colors.tertiary.g_400};
    border-radius: 50%;
    background: ${theme.colors.tertiary.g_400};
  `}
`

export const Loader = styled.div<LoaderProps>`
  border-radius: 50%;
  width: 20px;
  height: 20px;
  border: 3px solid ${({theme}) => `${theme.colors.secondary2_50}`};
  ${({theme, percent}) => {
    if (percent < 25) {
      return `
      border-top-color: ${theme.colors.tertiary.g_400};
    `
    } else if (percent < 50) {
      return `
        border-top-color: ${theme.colors.tertiary.g_400};
        border-left-color: ${theme.colors.tertiary.g_400};
      `
    } else if (percent < 75) {
      return `
        border-top-color: ${theme.colors.tertiary.g_400};
        border-left-color: ${theme.colors.tertiary.g_400};
        border-bottom-color: ${theme.colors.tertiary.g_400};
      `
    } else if (percent < 100) {
      return `
        border-top-color: ${theme.colors.tertiary.g_400};
        border-left-color: ${theme.colors.tertiary.g_400};
        border-bottom-color: ${theme.colors.tertiary.g_400};
        border-right-color: ${theme.colors.tertiary.g_400};
      `
    }
  }}
`
